import {
  SET_DADOS_INICIAIAS_PF_DOCUMENTO,
  LOADING_DADOS_INICIAIAS_PF_DOCUMENTO,
  ERROR_DADOS_INICIAIAS_PF_DOCUMENTO,

  SET_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  LOADING_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  ERROR_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  HANDLER_CHANGE_DADOS_INICIAIS_PF_ORGAOEMISSOR,

  CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM,
  HANDLER_CHANGE_DADOS_INICIAIS_PF_DOCUMENTO,
  HANDLER_CHANGE_DADOS_INICIAIS_PF_PAIS,

  SET_DADOS_INICIAIAS_PF_PAIS,
  LOADING_DADOS_INICIAIAS_PF_PAIS,
  ERROR_DADOS_INICIAIAS_PF_PAIS,

  LOADING_DADOS_INICIAIAS_PF_CPF,
  SET_DADOS_INICIAIAS_PF_CPF,
  ERROR_DADOS_INICIAIAS_PF_CPF,

  LOADING_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
  SET_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
  ERROR_DADOS_INICIAIAS_PF_CODIGO_GERENTE,

  LOADING_DADOS_INICIAIAS_PF_NOME_GERENTE,
  ERROR_DADOS_INICIAIAS_PF_NOME_GERENTE,

  SET_CODIGO_GERENTE_VIA_LINK,
  SET_ID_DDIPAIS_DADOS_INICIAIS_PF

} from './types';

const initialState = {
  formPF: {
    dadosIniciais_codigoGerente: '',
    dadosIniciais_nomeGerente: '',
    dadosIniciais_nomeCompleto: '',
    dadosIniciais_dataNascimento: '',
    dadosIniciais_cpf: '',
    dadosIniciais_numeroDocumento: '',
    dadosIniciais_orgaoEmissor: '',
    dadosIniciais_dataEmissao: '',
    dadosIniciais_dataVencimento: '',
    dadosIniciais_telefoneCelular: '',
    dadosIniciais_ddiTelefoneCelular: '55',
    dadosIniciais_email: '',
    dadosIniciais_nomeSocial:''
  },
  validateField: false,
  dadosIniciais_tipoDocumento: '',
  dadosIniciais_paisDocumento: 'BRA',
  dropdownDocumentoList: [],
  dropdownOrgaoEmissorList: [],
  typeaHeadDadosIniciaisPaisList: [],
  dadosIniciais_cpfExiste: null,
  dadosIniciais_codigoGerenteViaLink: false,
  dadosIniciais_idDDDpais: null,
  errorCodigoGerente: ""
}

export default function dadosIniciaisPFReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ID_DDIPAIS_DADOS_INICIAIS_PF:
      return {...state, dadosIniciais_idDDDpais: action.payload}
    case LOADING_DADOS_INICIAIAS_PF_CODIGO_GERENTE:
      return { ...state, loadingDadosGerente: action.payload }
    case SET_DADOS_INICIAIAS_PF_CODIGO_GERENTE:
      return { ...state, formPF: { ...state.formPF, dadosIniciais_codigoGerente: action.payload } }
    case ERROR_DADOS_INICIAIAS_PF_CODIGO_GERENTE:
      return { ...state, errorCodigoGerente: action.payload }

    case LOADING_DADOS_INICIAIAS_PF_NOME_GERENTE:
      return { ...state, loadingDadosGerente: action.payload }
    case ERROR_DADOS_INICIAIAS_PF_NOME_GERENTE:
      return { ...state, errorNomeGerente: action.payload }

    case SET_DADOS_INICIAIAS_PF_DOCUMENTO:
      return { ...state, dropdownDocumentoList: action.payload }
    case LOADING_DADOS_INICIAIAS_PF_DOCUMENTO:
      return { ...state, loadingDadosDocumento: action.payload }
    case ERROR_DADOS_INICIAIAS_PF_DOCUMENTO:
      return { ...state, errorListDadosDocumento: action.payload }

    case SET_DADOS_INICIAIAS_PF_ORGAOEMISSOR:
      return { ...state, dropdownOrgaoEmissorList: action.payload }
    case LOADING_DADOS_INICIAIAS_PF_ORGAOEMISSOR:
      return { ...state, loadingDadosOrgaoEmissor: action.payload }
    case ERROR_DADOS_INICIAIAS_PF_ORGAOEMISSOR:
      return { ...state, errorListDadosOrgaoEmissor: action.payload }
    case HANDLER_CHANGE_DADOS_INICIAIS_PF_ORGAOEMISSOR:
      return { ...state, formPF: { ...state.formPF, dadosIniciais_orgaoEmissor: action.payload } }


    case CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM:
      return { ...state, formPF: action.payload }
    case HANDLER_CHANGE_DADOS_INICIAIS_PF_DOCUMENTO:
      return { ...state, dadosIniciais_tipoDocumento: action.payload }

    case SET_DADOS_INICIAIAS_PF_PAIS:
      return { ...state, typeaHeadDadosIniciaisPaisList: action.payload }
    case LOADING_DADOS_INICIAIAS_PF_PAIS:
      return { ...state, loadingDadosPais: action.payload }
    case ERROR_DADOS_INICIAIAS_PF_PAIS:
      return { ...state, errorListDadosPais: action.payload }

    case HANDLER_CHANGE_DADOS_INICIAIS_PF_PAIS:
      return { ...state, dadosIniciais_paisDocumento: action.payload }

    case SET_DADOS_INICIAIAS_PF_CPF:
      return { ...state, dadosIniciais_cpfExiste: action.payload }
    case LOADING_DADOS_INICIAIAS_PF_CPF:
      return { ...state, loadingDadosExisteCpf: action.payload }
    case ERROR_DADOS_INICIAIAS_PF_CPF:
      return { ...state, errorBollDadosExisteCpf: action.payload }

    case SET_CODIGO_GERENTE_VIA_LINK:
      return { ...state, dadosIniciais_codigoGerenteViaLink: action.payload }

    default:
      return state
  }
}